import { Candidate, ICandidate } from './candidate';
import { ILanguage, Language } from './language';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Plan } from './plan';
import { Helpers } from '../../helpers';
import { IStatusValue } from '../../shared/components/gmc-status-input/gmc-status-input.component';

export interface IEssentialInfo {
  adminInfo?: boolean;
  dailyReport?: boolean;
  downloadCV?: boolean;
  personalInfo?: boolean;
}

export interface ISocialNetworks {
  facebook?: string;
  linkedin?: string;
  skype?: string;
  twitter?: string;
}

export interface IProfilePlan {
  expire_date?: Date;
  last_action_date?: Date;
  need_partners?: number;
  pay_date?: Date;
  plan_id?: Plan;
}

export interface IUserProfile {
  _id?: string;
  id?: number;
  favorite?: number;
  age?: number;
  last_name?: string;
  country?: string;
  essentialInfo?: IEssentialInfo;
  first_name?: string;
  city?: string;
  birthday?: Moment;
  candidate?: ICandidate;
  job_experience?: any[];
  languages?: ILanguage[];
  parent_id?: number;
  photo?: string;
  plan?: IProfilePlan;
  role?: string;
  role_name?: string;
  role_type?: string;
  personal_email?: IStatusValue[];
  personal_phone?: IStatusValue[];
  social_networks?: ISocialNetworks;
  status?: string;
  points?: number;

  [ key: string ]: any;
}

export class UserProfile {
  _id?: string;
  id?: number;
  age: number;
  first_name: string;
  last_name: string;
  birthday?: Moment;
  candidate?: Candidate;
  country: string;
  city: string;
  job_experience: any;
  languages: Language[];
  parent_id: number;
  photo: string;
  plan: IProfilePlan;
  role: string;
  role_name: string;
  favorite: number;
  role_type: string;
  personal_email: IStatusValue[];
  personal_phone: IStatusValue[];
  essentialInfo: IEssentialInfo;
  social_networks: ISocialNetworks;
  status: string;
  points: number;

  constructor( profile: IUserProfile = {} ) {
    this._id = profile._id;
    this.age = profile.age;
    this.favorite = profile.favorite;
    this.first_name = profile.first_name;
    this.last_name = profile.last_name;
    this.birthday = profile.birthday ? moment(profile.birthday) : null;
    this.country = profile.country;
    this.city = profile.city;
    this.id = profile.id;
    this.job_experience = profile.job_experience;
    this.languages = this.createLanguagesArray(profile.languages);
    this.parent_id = profile.parent_id;
    this.photo = profile.photo;
    this.plan = this.parsePlan(profile.plan);
    this.role = profile.role;
    this.role_name = profile.role_name;
    this.role_type = profile.role_type;
    this.personal_email = profile.personal_email;
    this.personal_phone = profile.personal_phone;
    this.essentialInfo = profile.essentialInfo || {};
    this.social_networks = profile.social_networks || {};
    this.status = profile.status;
    if ( this.role_name === 'Candidate' ) {
      this.candidate = new Candidate(profile.candidate);
    }
  }

  private createLanguagesArray( languages: ILanguage[] = [ new Language() ] ): Language[] {
    if ( languages.length === 0 ) {
      return [ new Language() ];
    }
    return languages.map(( language ) => new Language(language));
  }

  private parsePlan( planData: IProfilePlan = {} ): IProfilePlan {
    return {
      expire_date: Helpers.createDateFromString(planData.expire_date),
      last_action_date: Helpers.createDateFromString(planData.last_action_date),
      need_partners: planData.need_partners,
      pay_date: Helpers.createDateFromString(planData.pay_date),
      plan_id: planData.plan_id ? new Plan(planData.plan_id) : null
    };
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/profile.ts